import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionPanel,
} from '@americanexpress/dls-react';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import styles from './CenturionNetworkFAQs.module.scss';

interface FAQ {
  question: string;
  answer: string;
}

interface FAQSection {
  header?: string;
  questions?: FAQ[];
}

export const CenturionNetworkFAQs = () => {
  const { centurionNetwork } = useCommonContent() as {
    centurionNetwork?: {
      faqSection?: FAQSection;
    };
  };
  const faqSection = centurionNetwork?.faqSection;
  const { header, questions = [] } = faqSection ?? {};

  if (!header || questions.length === 0) {
    return null;
  }

  return (
    <section aria-labelledby="centurion-network-faqs-heading">
      <hr className="tw-my-10 tw-border-gray-300" />
      <h2
        id="centurion-network-faqs-heading"
        className="tw-heading-md-regular tw-mb-6 tw-text-gray-800"
      >
        {header}
      </h2>
      <Accordion
        id="centurion-network-faqs"
        isBordered={false}
        shouldAllowMultipleExpanded={true}
        className="tw-bg-gray-100"
      >
        {questions.map(({ question, answer }, index) => {
          const panelId = `centurion-network-faq-${index}`;

          return (
            <React.Fragment key={panelId}>
              <AccordionPanel
                id={panelId}
                heading={
                  <span className="tw-flex tw-min-h-12 tw-items-center">
                    <span className="tw-block important_tw-min-h-0">
                      {question}
                    </span>
                  </span>
                }
              />
              <AccordionContent
                aria-labelledby={panelId}
                className="important_tw-pb-6 important_tw-pt-0"
              >
                <div
                  className={`${styles.answer} tw-whitespace-pre-line tw-font-sans tw-text-base tw-text-gray-800 a-children_tw-text-link a-children_tw-underline`}
                  dangerouslySetInnerHTML={{ __html: answer }}
                />
              </AccordionContent>
            </React.Fragment>
          );
        })}
      </Accordion>
    </section>
  );
};
